// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__39dmu","item":"PaymentsMobile_item__3GV2Y","label":"PaymentsMobile_label__2MuLB","amount":"PaymentsMobile_amount__SleaS"};